import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
  getCountries,
  getCountryCallingCode,
  AsYouType,
} from "libphonenumber-js";

export default {
  loadCountries() {
    try {
      // Get all countries from the library
      const countryCodes = getCountries();

      // Map them to our format with emoji flags
      return countryCodes
        .map((code) => {
          return {
            code: code,
            dialCode: getCountryCallingCode(code),
            emoji: this.getCountryFlag(code),
            name: new Intl.DisplayNames(["en"], { type: "region" }).of(code),
          };
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    } catch (error) {
      console.error("Error loading countries:", error);
      // Fallback to a few common countries in case of error
      return [
        {
          code: "AE",
          dialCode: "971",
          emoji: "🇦🇪",
          name: "United Arab Emirates",
        },
        { code: "US", dialCode: "1", emoji: "🇺🇸", name: "United States" },
        { code: "GB", dialCode: "44", emoji: "🇬🇧", name: "United Kingdom" },
      ];
    }
  },

  getCountryFlag(countryCode) {
    // Convert country code to regional indicator symbols (emoji flag)
    const codePoints = [...countryCode].map(
      (char) => 127397 + char.charCodeAt(0)
    );
    return String.fromCodePoint(...codePoints);
  },

  formatPhoneNumber(nationalNumber, countryCode) {
    try {
      const dialCode = getCountryCallingCode(countryCode);

      // Format the number as the user types
      const formatter = new AsYouType(countryCode);
      const displayNumber = formatter.input(nationalNumber);

      // Clean up the national number (remove formatting)
      const cleanNationalNumber = nationalNumber.replace(/[^\d]/g, "");

      // Create the full international format
      const fullNumber = `+${dialCode}${cleanNationalNumber}`;

      // Validate it
      const isValid = isValidPhoneNumber(fullNumber, countryCode);

      return {
        formattedNumber: fullNumber,
        displayNumber: displayNumber,
        isValid: isValid,
      };
    } catch (error) {
      console.error("Error formatting phone number:", error);
      return {
        formattedNumber: nationalNumber,
        displayNumber: nationalNumber,
        isValid: false,
      };
    }
  },

  validatePhoneNumber(phoneNumber, countryCode) {
    if (!phoneNumber) {
      return { isValid: false, error: "Phone number is required" };
    }

    try {
      if (!isValidPhoneNumber(phoneNumber, countryCode)) {
        return { isValid: false, error: "Please enter a valid phone number" };
      }

      const parsedPhoneNumber = parsePhoneNumberFromString(phoneNumber);

      return {
        isValid: true,
        formattedNumber: parsedPhoneNumber.format("E.164"),
        nationalNumber: parsedPhoneNumber.nationalNumber,
        countryCode: parsedPhoneNumber.country,
      };
    } catch (error) {
      console.error("Phone validation error:", error);
      return { isValid: false, error: "Invalid phone number format" };
    }
  },
};
